// OMOTOR customized magnify — Dawn native in-place zoom, changed to activate on HOVER
// (stock Dawn requires a click). The underlying image is hidden while the zoom overlay
// is visible to prevent ghosting/double-image, and the overlay uses an opaque background.
// Clicks bubble up so the media container's handler can open the OMOTOR lightbox dialog.

function opMagRemove(image) {
  const overlay = image.parentElement.querySelector('.image-magnify-full-size');
  if (overlay) overlay.remove();
  image.style.visibility = '';
}

function opMagMove(image, event, zoomRatio) {
  const overlay = image.parentElement.querySelector('.image-magnify-full-size');
  if (!overlay) return;
  const ratio = image.height / image.width;
  const bounds = overlay.getBoundingClientRect();
  const xPosition = event.clientX - bounds.left;
  const yPosition = event.clientY - bounds.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function opMagCreate(image, zoomRatio) {
  if (image.parentElement.querySelector('.image-magnify-full-size')) return;
  const overlay = document.createElement('div');
  overlay.setAttribute('class', 'image-magnify-full-size');
  overlay.setAttribute('aria-hidden', 'true');
  overlay.style.backgroundImage = `url('${image.currentSrc || image.src}')`;
  overlay.style.backgroundColor = '#fff';
  overlay.style.backgroundRepeat = 'no-repeat';
  overlay.style.cursor = 'zoom-in';
  image.parentElement.insertBefore(overlay, image);
  // Hide the original image while zooming so it can't show through (ghosting fix).
  image.style.visibility = 'hidden';
  // Click clears the zoom and bubbles to the container, which opens the lightbox.
  overlay.onclick = () => opMagRemove(image);
  overlay.onmousemove = (event) => opMagMove(image, event, zoomRatio);
  overlay.onmouseleave = () => opMagRemove(image);
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    if (image.dataset.oproZoom) return;
    image.dataset.oproZoom = '1';
    image.onmouseenter = (event) => {
      opMagCreate(image, zoomRatio);
      opMagMove(image, event, zoomRatio);
    };
  });
}

enableZoomOnHover(2);
document.addEventListener('shopify:section:load', () => enableZoomOnHover(2));
